import { isSubsetGroup } from './isSubsetGroup';
import { processFlatFilter } from './processFlatFilter';

export const getFilterParamObject = (
  activeFilters: Record<string, any> | null
) => {
  const filtersObject: Record<string, any> = {};

  if (activeFilters) {
    Object.keys(activeFilters).forEach((key) => {
      const entry = { ...activeFilters[key] };
      // Subset/interdataset filters are nested under a `${datasetId}>` key: { field: { matchMode: value } }
      if (isSubsetGroup(key, entry)) {
        const inner: Record<string, any> = {};
        Object.keys(entry).forEach((field) => {
          inner[field] = processFlatFilter({ ...entry[field] });
        });
        filtersObject[key] = inner;
      } else {
        filtersObject[key] = processFlatFilter(entry);
      }
    });
  }

  return filtersObject;
};
